export default __webpack_public_path__ + "static/rylan_crying-98cdc51ea35baca8347c64051f7575aa.jpg";